import { useTranslation } from 'react-i18next'
import { UnsplashSearch } from './UnsplashSearch'
import { CoverImageUpload } from './CoverImageUpload'
import type { UnsplashPhoto } from '@/lib/api/features/unsplash'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface CoverImagePickerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSelectUnsplash: (photo: UnsplashPhoto) => void
  onUploadCustom: (file: File) => Promise<void>
  isUploading: boolean
  uploadProgress: number
}

export function CoverImagePicker({
  open,
  onOpenChange,
  onSelectUnsplash,
  onUploadCustom,
  isUploading,
  uploadProgress,
}: CoverImagePickerProps) {
  const { t } = useTranslation('common')
  const handleUnsplashSelect = (photo: UnsplashPhoto) => {
    onSelectUnsplash(photo)
    onOpenChange(false)
  }

  const handleUpload = async (file: File) => {
    await onUploadCustom(file)
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[520px]">
        <DialogHeader>
          <DialogTitle>{t('coverImage.title')}</DialogTitle>
        </DialogHeader>
        <Tabs defaultValue="unsplash" className="w-full">
          <TabsList className="w-full">
            <TabsTrigger value="unsplash" className="flex-1">
              Unsplash
            </TabsTrigger>
            <TabsTrigger value="custom" className="flex-1">
              Custom
            </TabsTrigger>
          </TabsList>
          <TabsContent value="unsplash" className="mt-3">
            <UnsplashSearch onSelect={handleUnsplashSelect} />
          </TabsContent>
          <TabsContent value="custom" className="mt-3">
            <CoverImageUpload
              onUpload={handleUpload}
              isUploading={isUploading}
              uploadProgress={uploadProgress}
            />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  )
}
